<template>
  <div>
    <v-progress-linear :indeterminate="true" v-if="loading && !session"></v-progress-linear>
    <div v-if="session">
      <v-row align="center">
        <v-col cols="12" md="6">
          <v-chip :color="color" dark class="mr-2">{{ statusLabel }}</v-chip>
          <span class="grey--text">{{ session.templateTitle }} · tablet {{ session.terminalCode }}</span>
        </v-col>
        <v-col cols="12" md="6" class="text-right">
          <span v-if="session.documentNumber" class="font-weight-bold">Dokument: {{ session.documentNumber }}</span>
          <span v-else-if="isActive" class="grey--text">ważna do {{ formatTime(session.expiresAt) }}</span>
          <span v-else-if="session.cancelReason" class="grey--text">powód: {{ cancelReasonLabel }}</span>
        </v-col>
      </v-row>
      <v-simple-table dense class="mt-2" v-if="session.audit && session.audit.length">
        <tbody>
          <tr v-for="(a, i) in session.audit" :key="i">
            <td style="width: 90px" class="grey--text">{{ formatTime(a.timestamp) }}</td>
            <td>{{ eventLabel(a.event) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-row v-if="isActive" class="mt-2" align="center">
        <v-col cols="12" md="5">
          <v-select v-model="cancelReason" :items="cancelReasons" label="Powód anulowania" dense outlined hide-details></v-select>
        </v-col>
        <v-col cols="12" md="7">
          <v-btn color="error" outlined :loading="cancelling" @click="cancel">Anuluj sesję</v-btn>
          <span class="ml-3 grey--text" v-if="cancelReason === 'REFUSED'">Odmowa zostanie odnotowana w audycie.</span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// Podgląd sesji podpisu na żywo: odpytuje SigningSession/Get co 2 s do stanu końcowego.
import { podpisyService, podpisyLabels, abpError } from "@/services/podpisy.service";
import { mapActions } from "vuex";
import dayjs from "dayjs";

const FINAL = ["SIGNED", "CANCELLED", "EXPIRED"];

export default {
  name: "SigningSessionStatus",
  props: ["sessionId"],
  data() {
    return {
      session: null,
      loading: false,
      cancelling: false,
      timer: null,
      cancelReason: "USER",
      cancelReasons: Object.keys(podpisyLabels.cancelReason).map(k => ({ value: k, text: podpisyLabels.cancelReason[k] })),
    };
  },
  computed: {
    isActive() {
      return this.session && FINAL.indexOf(this.session.status) < 0;
    },
    statusLabel() {
      return podpisyLabels.sessionStatus[this.session.status] || this.session.status;
    },
    color() {
      return podpisyLabels.sessionColor[this.session.status] || "grey";
    },
    cancelReasonLabel() {
      return podpisyLabels.cancelReason[this.session.cancelReason] || this.session.cancelReason;
    },
  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
    formatTime(v) {
      return v ? dayjs(v).format("HH:mm:ss") : "";
    },
    eventLabel(ev) {
      return podpisyLabels.event[ev] || ev;
    },
    load() {
      this.loading = true;
      podpisyService.getSession(this.sessionId).then(resp => {
        this.session = resp.data.result;
        if (!this.isActive) {
          this.stop();
          this.$emit("finished", this.session);
        }
      }).catch(e => {
        this.error(abpError(e, "Nie można pobrać stanu sesji"));
        this.stop();
      }).finally(() => { this.loading = false; });
    },
    start() {
      this.stop();
      this.load();
      this.timer = setInterval(() => this.load(), 2000);
    },
    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    },
    cancel() {
      this.cancelling = true;
      podpisyService.cancelSession(this.sessionId, this.cancelReason, null).then(() => {
        this.success("Sesja anulowana");
        this.load();
      }).catch(e => {
        this.error(abpError(e, "Nie można anulować sesji"));
      }).finally(() => { this.cancelling = false; });
    },
  },
  mounted() {
    this.start();
  },
  beforeDestroy() {
    this.stop();
  },
  watch: {
    sessionId() {
      this.session = null;
      this.start();
    },
  },
};
</script>
